module.exports = __webpack_public_path__ + "img/mb.cb95c00f.png";